import { DTOFigmaComponentListResponse } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

export class FigmaComponentsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  async list(dsId: string, vId: string) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${vId}/components`,
      DTOFigmaComponentListResponse
    );
  }
}
